import { generateBaseCSS } from './base';
import { generateHeaderCSS } from './header';
import { generateSectionsCSS } from './sections';
import { generateFooterCSS } from './footer';
import { generateCookieCSS } from './cookie';
import { generateLegalCSS } from './legal';
import { generatePremiumFxCSS } from './premium-fx';
import { generatePolishCSS } from './polish';

export function generateComponentsCSS(): string {
  return [
    generateBaseCSS(),
    generateHeaderCSS(),
    generateSectionsCSS(),
    generateFooterCSS(),
    generateCookieCSS(),
    generateLegalCSS(),
    generatePremiumFxCSS(),
    generatePolishCSS(),
  ].join('\n');
}
